const isSameEmail = (first: string | undefined, second: string | undefined): boolean =>
	first?.toLowerCase() === second?.toLowerCase();

export default isSameEmail;
